import common from './en/common.json'
import heading from './en/heading.json'
import label from './en/label.json'
import mtheading from './en/mtheading.json'
import mtlabel from './en/mtlabel.json'
import mtSummary from './en/mtSummary.json'
import validation from './en/validation.json'

export default {
  translation: {
    common,
    label,
    heading,
    validation,
    mtheading,
    mtlabel,
    mtSummary,
  },
}
